import React from 'react';

// One question in an accordion list; used on the home page and /faq
export default function FAQItem({ question, answer, isOpen, onClick }) {
  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button type="button" className="faq-question" onClick={onClick} aria-expanded={isOpen}>
        <h3>{question}</h3>
        <span className="faq-arrow" aria-hidden="true"></span>
      </button>
      <div className="faq-answer">
        <div className="faq-answer-inner">
          {Array.isArray(answer) ? answer.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          )) : <p>{answer}</p>}
        </div>
      </div>
    </div>
  );
}
